import { api } from '../../../../lib/api';
import { snakeCaseKeys } from '../../../../shared/helpers';

export const saveDeliverDraft = values => {
  const sendData = snakeCaseKeys(values);

  return api({
    method: 'post',
    url: `/api/client_admin/send/deliver/save`,
    data: { deliver: sendData },
  });
};

export const sendTest = values => {
  const sendData = snakeCaseKeys(values);

  return api({
    method: 'post',
    url: `/api/client_admin/send/deliver/send_test`,
    data: sendData,
  });
};

export const send = values => {
  const sendData = snakeCaseKeys(values);

  return api({
    method: 'post',
    url: `/api/client_admin/send/deliver/send_digest`,
    data: sendData,
  });
};
